// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"L7-z"};